/* WhatsApp contact button — shows the sidebar-rail WhatsApp slot during the
   configured hours (snippets/whatsapp-contact-button.liquid).

   Why client-side: the storefront is full-page cached, so a server-side (Liquid)
   time check would freeze into the cached HTML and be wrong for later visitors.
   Liquid emits a static schedule in #wa-contact-config; this script decides
   visibility at runtime in the visitor's browser and re-checks every minute so it
   flips at the hour boundary without a reload.

   Fail-safe: on any error (bad config, unsupported Intl) the slot stays hidden. */
(function () {
  "use strict";

  var CONFIG_ID = "wa-contact-config";
  var ACTIVE_CLASS = "wa-contact-active";
  var CHECK_INTERVAL_MS = 60000;
  var MINUTES_PER_DAY = 1440;
  var DOW = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };

  function readConfig() {
    var el = document.getElementById(CONFIG_ID);
    if (!el) return null;
    var cfg = JSON.parse(el.textContent);
    return cfg && cfg.schedule ? cfg : null;
  }

  // Current weekday (0=Sun..6=Sat) and minutes-since-midnight in the given IANA zone,
  // independent of the visitor's own timezone. Intl handles PST/PDT automatically.
  function nowInZone(timeZone) {
    var parts = new Intl.DateTimeFormat("en-US", {
      timeZone: timeZone,
      weekday: "short",
      hour: "2-digit",
      minute: "2-digit",
      hour12: false
    }).formatToParts(new Date());

    var map = {};
    for (var i = 0; i < parts.length; i++) map[parts[i].type] = parts[i].value;

    var hour = parseInt(map.hour, 10);
    if (hour === 24) hour = 0; // some engines emit "24" at midnight with hour12:false
    var minute = parseInt(map.minute, 10);
    return { dow: DOW[map.weekday], minutes: hour * 60 + minute };
  }

  // Window is [start, end) in minutes; end 1440 = "12:00 AM (end of day)", so
  // start 0 + end 1440 covers the whole day.
  function isWhatsAppTime(cfg) {
    var t = nowInZone(cfg.timeZone || "America/Los_Angeles");
    var day = cfg.schedule[String(t.dow)];
    if (!day || !day.enabled) return false;

    var start = parseInt(day.start, 10);
    var end = parseInt(day.end, 10);
    if (isNaN(start) || isNaN(end)) return false;
    if (end > MINUTES_PER_DAY) end = MINUTES_PER_DAY;

    var m = t.minutes;
    if (end > start) return m >= start && m < end;
    if (end < start) return m >= start || m < end; // overnight wrap
    return false; // start === end -> treated as closed
  }

  function init() {
    var cfg;
    try {
      cfg = readConfig();
    } catch (e) {
      return; // malformed config -> fail safe
    }
    if (!cfg) return;

    function recheck() {
      var isWa = false;
      try {
        isWa = isWhatsAppTime(cfg);
      } catch (e) {}
      document.documentElement.classList.toggle(ACTIVE_CLASS, isWa);
    }

    recheck();
    window.setInterval(recheck, CHECK_INTERVAL_MS);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
